import { Component, EventEmitter, Output, input } from '@angular/core';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { CurrenciesService } from '../../currencies/currencies.service';
import { TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';
import { checkBulkFieldTooltip } from '../utils/check-bulk-field-tooltip';

@Component({
  selector: 'pp-bulk-field-cost',
  templateUrl: './bulk-field-cost.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldCostComponent {
  ppCustomField = input<TCustomField>(undefined);
  ppCustomFields = input<TBulkCustomFields<number>>(undefined);
  ppFieldId = input<string>(undefined);
  ppCustomFieldsExtended = input<TBulkCustomFieldsExtended<number>>(undefined);
  ppDisabled = input<boolean>(false);

  @Output() ppCustomFieldsExtendedChange = new EventEmitter<TBulkCustomFieldsExtended>();
  @Output() ppCustomFieldsChange = new EventEmitter<TBulkCustomFields>();

  EIconPath = EIconPath;
  currencyName: string;
  tooltipText: string;
  disabled = false;

  constructor(private currenciesService: CurrenciesService) {}

  ngOnChanges(): void {
    this.disabled = this.ppDisabled() || this.ppCustomField()?.lockedValue;
    const currency = this.currenciesService.getCurrencyByCode(this.ppCustomField().currencyCode);
    this.tooltipText = checkBulkFieldTooltip(this.ppCustomField());

    this.currencyName = currency ? currency.currencyDisplayName : '';
  }

  updateCost(cost: string, field: TCustomField): void {
    if (this.ppCustomField().lockedValue) {
      return;
    }

    const customFieldsExtended = this.ppCustomFieldsExtended();
    const customFields = this.ppCustomFields();

    customFields[field.id] = +cost;

    customFieldsExtended[field.id] = {
      value: customFields[field.id],
      label: field.label,
      type: field.type,
    };

    this.ppCustomFieldsChange.emit(customFields);
    this.ppCustomFieldsExtendedChange.emit(customFieldsExtended);
  }
}
